/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Parent_LabelInputs */



/**
* | output |
* | --- |
* | "Parent League" |
*
* @param {League_Parent_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_parent_label = /** @type {((inputs?: League_Parent_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Parent_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ligue parente")
	if (locale === "es") return /** @type {LocalizedString} */ ("Liga padre")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Liga pai")
	if (locale === "it") return /** @type {LocalizedString} */ ("Campionato genitore")
	return /** @type {LocalizedString} */ ("Parent League")
});